import type {ReactElement} from 'react';
import {SkeletonBrick} from '@Components/skeleton-brick';
import {
  DROPDOWN_HEIGHT,
  ROW_LABEL_HEIGHT,
  ROW_LABEL_WIDTHS,
  SECTION_HEADER_HEIGHT,
  SECTION_HEADER_WIDTH,
  SLIDER_HEIGHT,
  SWATCH_HEIGHT,
  SWATCH_WIDTH,
  TITLE_BAR_TEXT_HEIGHT,
  TITLE_BAR_TEXT_WIDTH,
  TOOLBAR_TILE_COUNT,
  TOOLBAR_TILE_SIZE,
} from './right-panel-loading-skeleton.types';
import styles from './right-panel-loading-skeleton.module.scss';

export function RightPanelLoadingSkeleton(): ReactElement {
  return (
    <div aria-hidden className={styles.container}>
      <div className={styles.titleHeader}>
        <SkeletonBrick height={TITLE_BAR_TEXT_HEIGHT} width={TITLE_BAR_TEXT_WIDTH} />
      </div>
      <div className={styles.toolbar}>
        {Array.from({length: TOOLBAR_TILE_COUNT}, (_, i) => (
          <SkeletonBrick key={i} height={TOOLBAR_TILE_SIZE} width={TOOLBAR_TILE_SIZE} />
        ))}
      </div>
      <div className={styles.sectionHeader}>
        <SkeletonBrick height={SECTION_HEADER_HEIGHT} width={SECTION_HEADER_WIDTH} />
      </div>
      {renderSwatchRow(ROW_LABEL_WIDTHS[0])}
      {renderSliderRow(ROW_LABEL_WIDTHS[1])}
      {renderDropdownRow(ROW_LABEL_WIDTHS[2])}
      {renderSwatchRow(ROW_LABEL_WIDTHS[3])}
      {renderSliderRow(ROW_LABEL_WIDTHS[4])}
      {renderDropdownRow(ROW_LABEL_WIDTHS[5])}
    </div>
  );
}

function renderSwatchRow(labelWidth: number): ReactElement {
  return (
    <div className={styles.row}>
      <SkeletonBrick height={ROW_LABEL_HEIGHT} width={labelWidth} />
      <SkeletonBrick height={SWATCH_HEIGHT} width={SWATCH_WIDTH} />
    </div>
  );
}

function renderSliderRow(labelWidth: number): ReactElement {
  return (
    <div className={styles.stackedRow}>
      <SkeletonBrick height={ROW_LABEL_HEIGHT} width={labelWidth} />
      <SkeletonBrick height={SLIDER_HEIGHT} />
    </div>
  );
}

function renderDropdownRow(labelWidth: number): ReactElement {
  return (
    <div className={styles.stackedRow}>
      <SkeletonBrick height={ROW_LABEL_HEIGHT} width={labelWidth} />
      <SkeletonBrick height={DROPDOWN_HEIGHT} />
    </div>
  );
}
